/**
 * Capacity-tier buckets for completing a custom blend.
 * Uses the same bands customers already see on CapacityMark.
 */

export const BUCKET_ORDER = ['body', 'partner', 'accent'];

/**
 * @param {string|undefined} tier
 * @returns {'body'|'partner'|'accent'}
 */
export function capacityBucket(tier) {
  if (tier === 'full' || tier === 'high') return 'body';
  if (tier === 'mid') return 'partner';
  return 'accent';
}

/**
 * Prefer one strong partner per missing cup bucket, then fill by consensus.
 * @param {Array<{ familyKey: string, name: string, score: number, bucket: string, order?: number }>} ranked
 * @param {Set<string>} selectedBuckets
 * @param {number} max
 */
export function diversifyByBucket(ranked, selectedBuckets, max) {
  const picked = [];
  const used = new Set();

  for (const bucket of BUCKET_ORDER) {
    if (selectedBuckets.has(bucket)) continue;
    const candidate = ranked.find(
      (r) => r.bucket === bucket && !used.has(r.familyKey),
    );
    if (!candidate) continue;
    picked.push(candidate);
    used.add(candidate.familyKey);
    if (picked.length >= max) break;
  }

  if (picked.length < max) {
    for (const r of ranked) {
      if (used.has(r.familyKey)) continue;
      picked.push(r);
      used.add(r.familyKey);
      if (picked.length >= max) break;
    }
  }

  return picked.map(({ familyKey, name, score, bucket }) => ({
    familyKey,
    name,
    score,
    bucket,
  }));
}
